module.exports = __webpack_public_path__ + "img/album17_18.d3549e13.jpg";